module.exports = __webpack_public_path__ + "static/media/index_banner.90db2b2e.png";